import '../styles/theme.scss';

import $ from 'jquery';
import {pageLinkFocus} from '@shopify/theme-a11y';
import {cookiesEnabled} from '@shopify/theme-cart';
import {wrapTable, wrapIframe} from '@shopify/theme-rte';

import React from 'react';
import ReactDOM from 'react-dom';

import ProductApp from './components/Product/ProductApp';
import CartAction from './components/Cart/CartAction';
import CartContainer from './components/Cart/CartContainer';

window.slate = window.slate || {};
window.theme = window.theme || {};

/* = =============== Templates ================ */
// import './templates/customers-addresses';
// import './templates/customers-login.js';

// Init React Apps
// Common Apps
ReactDOM.render(<CartAction />, document.getElementById('CartToggleApp'));
ReactDOM.render(<CartContainer />, document.getElementById('CartApp'));

// Page Specific Apps
const productAppEl = document.getElementById('ProductApp');

if (productAppEl) {
  ReactDOM.render(<ProductApp />, productAppEl);
}

const $siteHeader = $('.js-site-header');

$('.js-show-menu').on('click', (e) => {
  e.preventDefault();
  $siteHeader.addClass('menu-active');
});

$('.js-hide-menu').on('click', (e) => {
  e.preventDefault();
  $siteHeader.removeClass('menu-active');
});

window.addEventListener('scroll', (e) => {
  const pastTop = window.scrollY > 75;
  document.body.classList.toggle('scrolled', pastTop);
});



    // If we reached this module (the entry point), it means no one accepted the HRM.
    // Let's reload the page then.
    if (module.hot) {
      module.hot.accept();

      // On first load, module.hot.data is undefined since it is not an update...
      // So if we do have a data object, it means we've been HMR'ed.
      if (module.hot.data) {
        window.__slate_should_reload__ = true;
      }
    }
  


// WEBPACK FOOTER //
// ./assets/scripts/theme.js